import React from "react";
import { SynonymGroup } from "../types";
import SynonymCard from "./SynonymCard";
import { useLanguage } from "../contexts/LanguageContext";
import { useTranslations } from "../translations";
import "./SearchResults.css";

interface SearchResultsProps {
  results: SynonymGroup[];
  query: string;
  isLoading: boolean;
}

const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  query,
  isLoading,
}) => {
  const { language } = useLanguage();
  const t = useTranslations(language);

  if (isLoading) {
    return (
      <div className="search-results">
        <div className="loading">{t.loading}</div>
      </div>
    );
  }

  if (!query) {
    return null;
  }

  if (results.length === 0) {
    return (
      <div className="search-results">
        <div className="no-results">
          {t.noResults} "{query}".
        </div>
      </div>
    );
  }

  return (
    <div className="search-results">
      <div className="results-header">
        <h2>
          {t.resultsFor} "{query}" ({results.length}{" "}
          {results.length === 1 ? t.group : t.groups})
        </h2>
      </div>

      {results.map((group, index) => (
        <div key={index} className="synonym-group">
          <h3 className="group-title">
            {t.synonymGroup}: {group.base_word}
          </h3>
          <div className="synonyms-list">
            {group.synonyms.map((synonym, synIndex) => (
              <SynonymCard key={synIndex} synonym={synonym} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SearchResults;
